/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    DateTimeRestrictionData,
    DateTimeRestrictionDataFromJSON,
    DateTimeRestrictionDataFromJSONTyped,
    DateTimeRestrictionDataToJSON,
    FormDataRouteRestriction,
    FormDataRouteRestrictionFromJSON,
    FormDataRouteRestrictionFromJSONTyped,
    FormDataRouteRestrictionToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    OsisRuleFormDataTravelDateRestriction,
    OsisRuleFormDataTravelDateRestrictionFromJSON,
    OsisRuleFormDataTravelDateRestrictionFromJSONTyped,
    OsisRuleFormDataTravelDateRestrictionToJSON,
} from './';

/**
 * 
 * @export
 * @interface OsisRuleFormDataBase
 */
export interface OsisRuleFormDataBase {
    /**
     * 
     * @type {Array<string>}
     * @memberof OsisRuleFormDataBase
     */
    accountCodes?: Array<string> | null;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof OsisRuleFormDataBase
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {string}
     * @memberof OsisRuleFormDataBase
     */
    comment?: string | null;
    /**
     * 
     * @type {Array<DateTimeRestrictionData>}
     * @memberof OsisRuleFormDataBase
     */
    dateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof OsisRuleFormDataBase
     */
    dateTimeRestrictionsTimeZone?: CodeAndLabel;
    /**
     * 
     * @type {string}
     * @memberof OsisRuleFormDataBase
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OsisRuleFormDataBase
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OsisRuleFormDataBase
     */
    excludeAccountCodes?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof OsisRuleFormDataBase
     */
    fareBasisCodes?: Array<string> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof OsisRuleFormDataBase
     */
    fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdCodeAndLabel>}
     * @memberof OsisRuleFormDataBase
     */
    marketingCarriers?: Array<GuidIdCodeAndLabel> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OsisRuleFormDataBase
     */
    osIs?: Array<string> | null;
    /**
     * 
     * @type {Array<FormDataRouteRestriction>}
     * @memberof OsisRuleFormDataBase
     */
    routes?: Array<FormDataRouteRestriction> | null;
    /**
     * 
     * @type {Array<OsisRuleFormDataTravelDateRestriction>}
     * @memberof OsisRuleFormDataBase
     */
    travelDates?: Array<OsisRuleFormDataTravelDateRestriction> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof OsisRuleFormDataBase
     */
    providers?: Array<GuidIdAndLabel> | null;
}

export function OsisRuleFormDataBaseFromJSON(json: any): OsisRuleFormDataBase {
    return OsisRuleFormDataBaseFromJSONTyped(json, false);
}

export function OsisRuleFormDataBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OsisRuleFormDataBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountCodes': !exists(json, 'accountCodes') ? undefined : json['accountCodes'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'dateTimeRestrictions': !exists(json, 'dateTimeRestrictions') ? undefined : (json['dateTimeRestrictions'] === null ? null : (json['dateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionDataFromJSON)),
        'dateTimeRestrictionsTimeZone': !exists(json, 'dateTimeRestrictionsTimeZone') ? undefined : CodeAndLabelFromJSON(json['dateTimeRestrictionsTimeZone']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'excludeAccountCodes': !exists(json, 'excludeAccountCodes') ? undefined : json['excludeAccountCodes'],
        'fareBasisCodes': !exists(json, 'fareBasisCodes') ? undefined : json['fareBasisCodes'],
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'marketingCarriers': !exists(json, 'marketingCarriers') ? undefined : (json['marketingCarriers'] === null ? null : (json['marketingCarriers'] as Array<any>).map(GuidIdCodeAndLabelFromJSON)),
        'osIs': !exists(json, 'osIs') ? undefined : json['osIs'],
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(FormDataRouteRestrictionFromJSON)),
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(OsisRuleFormDataTravelDateRestrictionFromJSON)),
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function OsisRuleFormDataBaseToJSON(value?: OsisRuleFormDataBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accountCodes': value.accountCodes,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'comment': value.comment,
        'dateTimeRestrictions': value.dateTimeRestrictions === undefined ? undefined : (value.dateTimeRestrictions === null ? null : (value.dateTimeRestrictions as Array<any>).map(DateTimeRestrictionDataToJSON)),
        'dateTimeRestrictionsTimeZone': CodeAndLabelToJSON(value.dateTimeRestrictionsTimeZone),
        'description': value.description,
        'disabled': value.disabled,
        'excludeAccountCodes': value.excludeAccountCodes,
        'fareBasisCodes': value.fareBasisCodes,
        'fareTypes': value.fareTypes === undefined ? undefined : (value.fareTypes === null ? null : (value.fareTypes as Array<any>).map(CodeAndLabelToJSON)),
        'marketingCarriers': value.marketingCarriers === undefined ? undefined : (value.marketingCarriers === null ? null : (value.marketingCarriers as Array<any>).map(GuidIdCodeAndLabelToJSON)),
        'osIs': value.osIs,
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(FormDataRouteRestrictionToJSON)),
        'travelDates': value.travelDates === undefined ? undefined : (value.travelDates === null ? null : (value.travelDates as Array<any>).map(OsisRuleFormDataTravelDateRestrictionToJSON)),
        'providers': value.providers === undefined ? undefined : (value.providers === null ? null : (value.providers as Array<any>).map(GuidIdAndLabelToJSON)),
    };
}


